import React from 'react';

const Help = function () {
  return (
    <div className="container text-page">
      <h1>Aide</h1>
      <ul>
        <li>Cliquez sur la carte pour ajouter un parc (utilisateurs connectés uniquement).</li>
        <li>Cliquez sur un point pour obtenir des informations.</li>
      </ul>
    </div>
  );
};

export default Help;
